import { action, app } from "photoshop";
import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";

async function onDocumentChanged() {
	const activeDocument = app.activeDocument;
	postToRenderer([
		{
			key: "documentInfoChanged",
			id: uuidv4(),
			values: {
				width: activeDocument?.width || 0,
				height: activeDocument?.height || 0,
			},
		},
	]);

	return;
}

export function useDocumentChangedEvent() {
	useListenFromRenderer([
		{
			key: "listenDocumentInfoChanged",
			onMessage: async (message) => {
				if (message.values.type === "add") {
					onDocumentChanged();
					action.addNotificationListener(
						[
							"historyStateChanged",
							"open",
							"make",
							"set",
							"select",
							"close",
							"revert",
							"imageSize",
							"canvasSize",
						],
						onDocumentChanged,
					);
				}
				if (message.values.type === "remove") {
					action.removeNotificationListener(
						[
							"historyStateChanged",
							"open",
							"make",
							"set",
							"select",
							"close",
							"revert",
							"imageSize",
							"canvasSize",
						],
						onDocumentChanged,
					);
				}
			},
		},
	]);
}
